import React from 'react';
import { Link, useNavigate } from 'react-router-dom';
import SmartTable from 'views/common/table/SmartTable';
import { Input, Select, Tag } from 'antd';
import { ReactComponent as UserIcon } from 'assets/svg/user.svg';
import {
  checkHasAnyRoleOrPermission,
  PERMISSION,
  ROLE,
} from 'constants/permission';
import configEnv from 'env';
import Page from 'views/common/Page';
import { LIST_TYPE } from 'constants/constants';
import usePage from 'hooks/usePage';
import { useSelector } from 'react-redux';

const config = {
  mainKey: 'userId',
  name: 'manage-users',
  headerHeight: 50,
  rowHeight: 60,
  tableStyle: {
    minWidth: 700
  },
  columns: [
    {
      columnKey: 'No',
      title: 'No.',
      className: 'cell-y-center',
      render: (v, rowData) => {
        const { index } = rowData;
        return <span style={{ fontWeight: 400, paddingLeft: 5 }}>{index}</span>;
      },
      width: '2rem',
    },
    {
      columnKey: 'email',
      title: 'Email',
      width: '20%',
      className: 'cell-y-center',
      
      render: (v, rowData) => {
        return (
          <div className="user-cell">
            <div className="user-cell__avatar">
              {rowData.avatar ? (
                <img
                  src={
                    rowData.avatar &&
                    `${configEnv.STORAGE_BASE_URL}/user/${rowData.avatar}`
                  }
                  alt="user"
                />
              ) : (
                <UserIcon />
              )}
            </div>
            <div className="user-cell__info">
              <Link
                className="cell-link-to"
                to={`/user/${rowData.userId}`}
              >
                <span className="text">{rowData.email}</span>
              </Link>
            </div>
          </div>
        );
      },
    },
    {
      columnKey: 'fullName',
      title: 'Full Name',
      width: '20%',
      
      className: 'cell-y-center',
    },
    {
      columnKey: 'userId',
      title: 'User ID',
      width: '20%',
      
      className: 'cell-y-center',
    },
    {
      columnKey: 'accountType',
      title: 'Account Type',
      width: '20%',
      
      className: 'cell-y-center',
      render: (v) => {
        return (
          <Tag color={v === 'INTERNAL' ? 'yellow' : 'green'}>
            {v === 'INTERNAL' ? 'Internal' : 'External'}
          </Tag>
        );
      },
    },
    {
      columnKey: 'createdDate',
      title: 'Create Date',
      width: '15%',
      
      className: 'cell-y-center',
    },
    {
      columnKey: 'disabled',
      title: 'Status',
      width: '7%',
      
      className: 'cell-y-center',
      render: (v) => {
        return (
          <Tag color={v ? 'red-inverse' : 'green-inverse'}>
            {!v ? 'Active' : 'Inactive'}
          </Tag>
        );
      },
    },
  ],
};

const { Option } = Select;

const ManagerUsers = () => {
  const {
    status,
    data,
    meta,
    search,
    onChangeFieldText,
    onChangeField,
    onChangePage,
    currentPage,
  } = usePage({
    name: LIST_TYPE.USER,
    pageSize: 10,
  });
  const navigate = useNavigate();
  const { permissions, roles } = useSelector((state) => state.auth);

  return (
    <Page
      title="User"
      status={status}
      data={data}
      currentPage={currentPage}
      onCreate={
        checkHasAnyRoleOrPermission(
          permissions,
          roles,
          [ROLE.SYSTEM_ADMIN],
          [PERMISSION.CREATE_AUTHORIZATION]
        )
          ? () => navigate('/user/create')
          : null
      }
      pageSize={10}
      onChangePage={onChangePage}
      meta={meta}
      renderSearch={() => (
        <div className="page-search">
          <Input
            value={search.query}
            className="page-search__input"
            onChange={(e) => onChangeFieldText(e, 'query')}
            placeholder="Search for Username, Full Name, Email, User ID, Company"
            size="large"
          />

          <Select
            allowClear
            placeholder="Status"
            onChange={(v) => onChangeField(v, 'disable')}
            value={search.disable}
            className="page-search__select"
            size="large"
          >
            <Option value={false}>Active</Option>
            <Option value={true}>Inactive</Option>
          </Select>

          <Select
            allowClear
            placeholder="Type"
            onChange={(v) => onChangeField(v, 'accountType')}
            value={search.accountType}
            className="page-search__select"
            size="large"
          >
            <Option value="INTERNAL">Internal</Option>
            <Option value="EXTERNAL">External</Option>
          </Select>
        </div>
      )}
      renderList={() => (
        <div className="table-item-wraper">
          <SmartTable
            config={config}
            navigate={navigate}
            dataSource={data || []}
          />
        </div>
      )}
    />
  );
};

export default ManagerUsers;
